import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const TaskDetailSkeleton = () => {
  return (
    <div className="task-detail-skeleton" style={{ width: '100%', marginTop: 12 }}>
      {/* Steps Timeline Skeleton */}
      <Card bordered={false} style={{ width: '100%', marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16, marginBottom: 20 }}>
          {Array.from({ length: 4 }).map((_, idx) => (
            <div key={'step_' + idx} style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 160 }}>
              <Skeleton.Avatar active size={32} shape="circle" />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
                <Skeleton.Input active size="small" style={{ width: '80%', height: 14, borderRadius: 3 }} />
                <Skeleton.Input active size="small" style={{ width: '50%', height: 10, borderRadius: 3 }} />
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 12, borderTop: '1px solid #f0f0f0' }}>
          <Skeleton.Button active size="small" style={{ width: 120, height: 32, borderRadius: 4 }} />
          <Skeleton.Button active size="small" style={{ width: 130, height: 32, borderRadius: 4 }} />
        </div>
      </Card>

      {/* Task Document Header Card */}
      <Card bordered={false} style={{ width: '100%', marginBottom: 16, textAlign: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: '8px 0 16px' }}>
          <Skeleton.Input active style={{ width: 220, height: 18, borderRadius: 3 }} />
          <Skeleton.Input active style={{ width: 340, height: 16, borderRadius: 3 }} />
          <Skeleton.Input active style={{ width: 280, height: 20, borderRadius: 3 }} />
        </div>

        {/* Info Table Skeleton */}
        <div style={{ border: '1px solid #f0f0f0', borderRadius: 4, overflow: 'hidden', marginTop: 12 }}>
          {Array.from({ length: 5 }).map((_, rIdx) => (
            <div
              key={'trow_' + rIdx}
              style={{
                display: 'flex',
                borderBottom: rIdx === 4 ? 'none' : '1px solid #f0f0f0',
                backgroundColor: rIdx % 2 === 0 ? '#fafafa' : '#ffffff'
              }}
            >
              <div style={{ width: '35%', padding: '12px 16px', borderRight: '1px solid #f0f0f0' }}>
                <Skeleton.Input active size="small" style={{ width: '85%', height: 14, borderRadius: 3 }} />
              </div>
              <div style={{ width: '65%', padding: '12px 16px' }}>
                <Skeleton.Input active size="small" style={{ width: '' + (50 + (rIdx * 11) % 40) + '%', height: 14, borderRadius: 3 }} />
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Collapsible Panels Placeholder */}
      {Array.from({ length: 3 }).map((_, pIdx) => (
        <Card
          key={'panel_' + pIdx}
          size="small"
          bordered={false}
          style={{ width: '100%', marginBottom: 12, backgroundColor: '#ffffff', borderRadius: 4, border: '1px solid #f0f0f0' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 8px' }}>
            <Skeleton.Input active size="small" style={{ width: 240 + pIdx * 40, height: 16, borderRadius: 3 }} />
            <Skeleton.Button active size="small" shape="circle" style={{ width: 18, height: 18 }} />
          </div>
        </Card>
      ))}
    </div>
  );
};

export default TaskDetailSkeleton;

